module.exports = __webpack_public_path__ + "static/media/vst_logo_signin.1f68a920.svg";